export default (props) => (
  /**
   * Ícone linha na listagem de classes da classificação por atributo
   * quando camada é do tipo linha.
   * Cor parametrizada.   
   */
  <svg
    width={18}
    height={3}
    viewBox="0 0 18 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      x1={0.339844}
      y1={1.82812}
      x2={17.5352}
      y2={1.82812}
      stroke={props.fill || 'currentColor'}
      strokeWidth={2}
    />
  </svg>
);
